import { Id } from "PFTypes";

export const usersKeys = {
  all: (params = {}) => ["users", params],
  imports: (params = {}) => [...usersKeys.all(), "imports", ...(params ? [params] : [])],
  importRows: (importId: Id, params = {}) => [
    ...usersKeys.all(),
    "importRows",
    importId,
    ...(params ? [params] : [])
  ]
};
